import { cn as e } from "../cn.js";
import { PageWrapper as t } from "../page-wrapper/index.js";
import { ScreenState as n } from "../screen-state/index.js";
import { Tabs as r } from "../tabs/index.js";
import { getStyles as i } from "./style.js";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
// src/design/list-screen/index.tsx
var s = ({ children: e, ...n }) => /* @__PURE__ */ a(t, {
	spacing: "md",
	...n,
	children: e
}), c = ({ title: e, description: n, actions: r, className: i }) => /* @__PURE__ */ o(t.Header, {
	actions: r,
	className: i,
	children: [/* @__PURE__ */ a(t.Title, { children: e }), n ? /* @__PURE__ */ a(t.Description, { children: n }) : null]
}), l = ({ className: t, children: n }) => /* @__PURE__ */ a("div", {
	className: e(i().filters(), t),
	children: n
}), u = ({ value: t, className: n, children: o }) => /* @__PURE__ */ a(r.Content, {
	value: t,
	className: e(i().tabPanel(), n),
	children: /* @__PURE__ */ a("div", {
		className: i().tabPanelBody(),
		children: o
	})
}), d = (e) => /* @__PURE__ */ a(t.Content, { children: /* @__PURE__ */ a(n, { ...e }) }), f = Object.assign(({ title: e, description: t, actions: n, filters: r, className: i, children: u, ...f }) => /* @__PURE__ */ o(s, {
	className: i,
	children: [
		/* @__PURE__ */ a(c, {
			title: e,
			description: t,
			actions: n
		}),
		r ? /* @__PURE__ */ a(l, { children: r }) : null,
		/* @__PURE__ */ a(d, {
			...f,
			children: u
		})
	]
}), {
	Root: s,
	Header: c,
	Filters: l,
	TabPanel: u,
	Body: d
});
export { f as ListScreen };

//# sourceMappingURL=index.js.map